import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=5be2f43e&scoped=true&lang=pug"
import script from "./CheckboxComponent.vue?vue&type=script&lang=ts"
export * from "./CheckboxComponent.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=5be2f43e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be2f43e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be2f43e')) {
      api.createRecord('5be2f43e', component.options)
    } else {
      api.reload('5be2f43e', component.options)
    }
    module.hot.accept("./CheckboxComponent.vue?vue&type=template&id=5be2f43e&scoped=true&lang=pug", function () {
      api.rerender('5be2f43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Checkbox/CheckboxComponent.vue"
export default component.exports